export enum SnackBarType {
	error = 'error',
	success = 'success'
}
